import { render, staticRenderFns } from "./homepage_task_mo.vue?vue&type=template&id=5b24d3cf&scoped=true&lang=html&"
import script from "./homepage_task_mo.vue?vue&type=script&lang=js&"
export * from "./homepage_task_mo.vue?vue&type=script&lang=js&"
import style0 from "./homepage_task_mo.vue?vue&type=style&index=0&id=5b24d3cf&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b24d3cf",
  null
  
)

export default component.exports